import React from "react";
import "./footer.css";
import { RiLinkedinBoxFill } from "react-icons/ri";
import { RiGithubFill } from "react-icons/ri";
import { RiTwitterXFill } from "react-icons/ri";
import { AiOutlineCopyrightCircle } from "react-icons/ai";

function Footer() {
  return (
    <div className="footer_container" id="footer">
      <div className="footer_social_btnGrp">
        <a href="https://www.linkedin.com/in/amaan-siddiqui-4512a2134">
          <button className="social__btn linkedin">
            <RiLinkedinBoxFill size={"5em"} />
          </button>
        </a>
        <a href="https://github.com/glennex">
          <button className="social__btn github">
            <RiGithubFill size={"5em"} />
          </button>
        </a>
        <a href="https://twitter.com/__Amaan__a">
          <button className="social__btn twitter">
            <RiTwitterXFill size={"5em"} />
          </button>
        </a>
      </div>
      <span>
        <p>
          <AiOutlineCopyrightCircle />
        </p>{" "}
        Made by Amaan Siddiqui
      </span>
    </div>
  );
}

export default Footer;
